import _ from 'lodash';
import { customerAlias } from './customerAlias';
import { numFormat } from './numFormat';

export function salesForecast(salesForecastData: any[], forecastYear: number): any[] {
  if(!salesForecastData || salesForecastData.length == 0) return [];
  const forecastByGroups = _.groupBy(salesForecastData, 'group._id');
  const formattedForecastData: any[] = [];
  let totalSalesToDate = 0;
  let totalFcToDate = 0;
  Object.keys(forecastByGroups).forEach((groupId: string) => {
    let groupSalesToDate = 0;
    let groupFcToDate = 0;
    const groupForecastBySalesman = _.groupBy(forecastByGroups[groupId], 'salesman._id');
    Object.keys(groupForecastBySalesman).forEach((salesmanId: string) => {
      let salesmanSalesToDate = 0;
      let salesmanFcToDate = 0;
      groupForecastBySalesman[salesmanId].forEach((forecastData: any) => {
        const salesToDate = _.get(forecastData, 'salesToDate', 0);
        const fcToDate = _.get(forecastData, 'totalFC', 0);
        const change = fcToDate - salesToDate;
        const changePercent = salesToDate ? numFormat(change/salesToDate * 100)+'%' : 'New';
        formattedForecastData.push({
          groupName: _.get(forecastData, 'group.name'),
          salesman: _.get(forecastData, 'salesman.displayName'),
          customer: customerAlias(_.get(forecastData, 'customer')),
          customerForecastUrl: `/sales-forecast?customer=${forecastData.customer._id}&year=${forecastYear}&displaySAR=true`,
          salesToDate: numFormat(salesToDate),
          totalFC: numFormat(fcToDate),
          change: numFormat(change),
          changePercent
        });
        salesmanSalesToDate = salesmanSalesToDate + salesToDate;
        salesmanFcToDate = salesmanFcToDate + fcToDate;
      });
      const salesmanChange = salesmanFcToDate - salesmanSalesToDate;
      const salesmanChangePercent = salesmanSalesToDate ? numFormat(salesmanChange/salesmanSalesToDate * 100) + '%' : 'New';
      formattedForecastData.push({
        salesman: 'Salesman Total',
        salesToDate: numFormat(salesmanSalesToDate),
        totalFC: numFormat(salesmanFcToDate),
        change: numFormat(salesmanChange),
        changePercent: salesmanChangePercent
      });
      groupSalesToDate = groupSalesToDate + salesmanSalesToDate;
      groupFcToDate = groupFcToDate + salesmanFcToDate;
    });
    const groupChange = groupFcToDate - groupSalesToDate;
    const groupChangePercent = groupSalesToDate ? numFormat(groupChange / groupSalesToDate * 100) + '%' : 'New';
    formattedForecastData.push({
      groupName: 'Group Total',
      salesToDate: numFormat(groupSalesToDate),
      totalFC: numFormat(groupFcToDate),
      change: numFormat(groupChange),
      changePercent: groupChangePercent
    });
    totalSalesToDate = totalSalesToDate + groupSalesToDate;
    totalFcToDate = totalFcToDate + groupFcToDate;
  });
  const totalChange = totalFcToDate - totalSalesToDate;
  const totalChangePercent = totalChange / totalSalesToDate * 100;
  formattedForecastData.push({
    groupName: 'Grand Total',
    salesToDate: numFormat(totalSalesToDate),
    totalFC: numFormat(totalFcToDate),
    change: numFormat(totalChange),
    changePercent: numFormat(totalChangePercent)+ '%'
  });
  return formattedForecastData;
}